import { memo } from 'preact/compat';
import { getImageUri } from '@/utils';

function getMediaStyle({ properties = {} }) {
	if (
		properties.mediatype === 'image' &&
		['jpg', 'jpeg', 'gif', 'png', 'svg'].indexOf(properties.location.split('.').pop()) >
			-1
	) {
		return {
			textAlign: properties.media_align ? properties.media_align : 'left'
		};
	} else if (
		['youtube', 'vimeo'].indexOf(properties.mediatype) > -1 &&
		properties.location.match(
			/^(https\:\/\/youtube)|^(https\:\/\/www\.youtube)|^(https\:\/\/player\.vimeo)/gi
		)
	) {
		return {
			width: properties.media_width,
			margin:
				properties.media_align === 'right'
					? '0 0 0 auto'
					: properties.media_align === 'center'
					? 'auto'
					: '0'
		};
	} else {
		return null;
	}
}

function Media({ block }) {
	const { properties } = block;
	if (block.type === 'img') {
		//thanks page in conversational
		return (
			<img
				src={block.url}
				title={block.properties?.alt ?? block.title ?? ''}
				alt={block.properties?.alt ?? ''}
				style={{
					height: 'auto',
					width: '100%'
				}}
			/>
		);
	} else if (
		properties.mediatype === 'image' &&
		['jpg', 'jpeg', 'gif', 'png', 'svg'].indexOf(properties.location.split('.').pop()) >
			-1
	) {
		return (
			<img
				title={block.properties?.alt ?? block.title ?? ''}
				alt={block.properties?.alt ?? ''}
				src={getImageUri(properties.location)}
				style={{
					height: 'auto',
					width: properties.media_width || '100%'
				}}
			/>
		);
	} else if (
		['youtube', 'vimeo'].indexOf(properties.mediatype) > -1 &&
		properties.location.match(
			/^(https\:\/\/youtube)|^(https\:\/\/www\.youtube)|^(https\:\/\/player\.vimeo)/gi
		)
	) {
		return (
			<div
				style={{
					padding: '56.25% 0 0 0',
					position: 'relative'
				}}
			>
				<iframe
					title={block.title}
					class="video-frame"
					src={properties.location}
					frameborder={0}
					allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen
					style={{
						height: '100%',
						width: '100%',
						position: 'absolute',
						top: 0,
						left: 0
					}}
				/>
			</div>
		);
	}
}

export default memo(
	function Multimedia({ block }) {
		return (
			<div
				id={`multimedia_${block.id}`}
				style={getMediaStyle(block)}
				class="section-multimedia"
			>
				<Media block={block} />
			</div>
		);
	},
	() => false
);
